import React, { useEffect } from 'react';
import BurgerSafetyBlog from './BurgerSafetyBlog';
import ContentPageLayout from './ContentPageLayout';

const BurgerSafetyBlogPage: React.FC = () => {
    useEffect(() => {
        document.title = 'How to Cook Burgers Safely - DeliFeed';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Learn how to cook burgers safely at home with proper temperatures and food safety practices. Essential guide from DeliFeed.');
        }
    }, []);

    return (
        <ContentPageLayout title="How to Cook Burgers Safely">
            <BurgerSafetyBlog />
        </ContentPageLayout>
    );
};

export default BurgerSafetyBlogPage;
